import i18n from "i18next";

export const getCurrentLanguage = () => {
    const languageSet = i18n.language || (typeof window !== 'undefined' && window.localStorage.i18nextLng)
    return !languageSet || languageSet === 'disabled' || (languageSet || '').match(/^en[-]?\w*$/)
        ? 'en'
        : languageSet;
};